<template>
  <v-container>
    <v-layout>
      <v-col>
        <v-flex v-if="para">
          <p v-for="(para, idx) in main" :key="idx" v-html="md(para)" />
        </v-flex>
        <v-layout  v-if="!!readMore">
          <v-flex :style="moreShowing ? 'display:none;' : ''">
            <v-btn small v-on:click="showMore">{{ readMore.button }}</v-btn>
          </v-flex>
        </v-layout>
        <v-flex v-if="!!readMore" :style="!moreShowing ? 'display:none;' : ''">
          <p v-for="(para, idx) in readMore.text" :key="idx" v-html="md(para)" />
        </v-flex>
      </v-col>
    </v-layout>
  </v-container>
</template>

<script>
import marked from 'marked'

export default {
  name: 'LayoutIntro',
  props: {
    lang: String,
    title: String,
    warningMsg: String,
    main: Array,
    readMore: Object
  },
  data: function() {
    return {
      moreShowing: false
    }
  },
  methods: {
    md: function(content) {
      return marked(content)
    },
    toggleLang: function() {
      this.$store.commit('toggleLang');
    },
    showMore: function() {
      this.moreShowing = true
    }
  }
}
</script>

<style scoped>


.active {
  font-weight: bold;
}
.inactive {
  color: grey;
}
.inactive:hover {
  cursor: pointer;
}
</style>
